import Formsy from 'formsy-react'
import FormsyInput from 'shared/components/Textfield/withFormsy'
import featureToggles from 'shared/featureToggles'
import DocumentDataFields from 'shared/components/DocumentDataFields'
import { withTranslate } from 'i18n/utils'

// This form is validated through ´personalDataFormRef´ rather than being submitted, so the
// fields are told explicitly when to reveal their errors
const $PersonalDetailsForm = ({ formData, onChangeFormData, translate: t, personalDataFormRef, showSubmitErrors }) => (
    <Formsy ref={personalDataFormRef}>
        <FormsyInput
            id="firstName"
            className="mt-1 mb-1"
            name="firstName"
            value={formData.firstName}
            type="text"
            label={t('guest.booking.personal.details.form.first.name')}
            validationError={t('input.required.error.message')}
            onChange={onChangeFormData}
            autoComplete="given-name"
            required
            showSubmitErrors={showSubmitErrors}
        />
        <FormsyInput
            id="lastName"
            className="mt-1 mb-1"
            name="lastName"
            value={formData.lastName}
            type="text"
            label={t('guest.booking.personal.details.form.last.name')}
            validationError={t('input.required.error.message')}
            onChange={onChangeFormData}
            autoComplete="family-name"
            required
            showSubmitErrors={showSubmitErrors}
        />
        <FormsyInput
            id="email"
            className="mt-1 mb-1"
            name="email"
            value={formData.email}
            type="email"
            label={t('guest.booking.personal.details.form.email')}
            validationError={t('input.email.pattern.mismatch.error.message')}
            validations="isEmail"
            onChange={onChangeFormData}
            autoComplete="email"
            required
            showSubmitErrors={showSubmitErrors}
        />
        <FormsyInput
            id="phone"
            className="mt-1 mb-1"
            name="phone"
            value={formData.phone}
            type="text"
            label={t('guest.booking.personal.details.form.phone')}
            validationError={t('input.required.error.message')}
            onChange={onChangeFormData}
            autoComplete="tel"
            required
            showSubmitErrors={showSubmitErrors}
        />
        {(featureToggles.brNeoPurchaseFlow || featureToggles.isColumbia) && (
            <DocumentDataFields
                onChange={onChangeFormData}
                documentType={formData.documentType}
                showSubmitErrors={showSubmitErrors}
            />
        )}
    </Formsy>
)

export const PersonalDetailsForm = compose(withTranslate)($PersonalDetailsForm)
